import React from 'react';
import InfoIcon from "@material-ui/icons/InfoRounded";
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const Info = ({ }) => (
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  <a target="_blank" rel="noopener" onClick={() => {
    if (!PACK) {
      if (window.Beacon) {
        window.Beacon('open');
      }
      return;
    }

    let helpWindow = Ext.create("TL.packs.help.Window", {
      width: 850,
      height: 500,
      helpTips: PACK["help_tips"],
      isAdmin: PACK["is_admin"],
      packId: PACK["id"]
    });

    helpWindow.show();
  }} style={{ textDecoration: "none" }}>
    <Grid container direction="row" className='info'>
      <InfoIcon />
      <span className="help_text">Help</span>
    </Grid>
  </a>
);

export default Info;